import { useState } from 'react';
import { Box, Button, Group, LoadingOverlay, Modal, Stack, Text } from '@mantine/core';

interface MantineDeleteModalProps {
  title: string;
  label?: string;
  body?: React.ReactNode;
  opened: boolean;
  close: () => void;
  /** May be sync or async. While the returned promise is in flight, the confirm
   * button is disabled/loading to prevent duplicate submits. */
  callBack: () => void | Promise<void>;
  cancelCallBack?: () => void;
  loading?: boolean;
  /** Text for cancel button */
  cancelButtonText?: string;
  /** Text for confirm/action button */
  confirmButtonText?: string;
  size?: string;
}
export const MantineDeleteModal = ({
  label = '¿Seguro que quieres eliminar este elemento?',
  title = 'Eliminar',
  body,
  opened,
  close,
  callBack,
  cancelCallBack,
  loading,
  cancelButtonText = 'Cancelar',
  confirmButtonText = 'Eliminar',
  size = 'lg',
}: MantineDeleteModalProps) => {
  const [submitting, setSubmitting] = useState(false);
  const isBusy = submitting || Boolean(loading);

  const handleCallback = async () => {
    if (isBusy) return;
    setSubmitting(true);
    try {
      await callBack();
    } finally {
      setSubmitting(false);
      close();
    }
  };
  const handleClose = () => {
    if (isBusy) return;
    if (cancelCallBack) {
      cancelCallBack();
    }
    close();
  };
  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title={
        <Text p={'md'} size={'26px'} fw={700}>
          {title}
        </Text>
      }
      p={'md'}
      centered
      size={size}
      transitionProps={{
        transition: 'fade',
        duration: 200,
      }}
      closeButtonProps={{
        mr: 'md',
        size: 'lg',
      }}
    >
      <Box px={'md'} pt={0} pb={'md'}>
        <LoadingOverlay
          visible={isBusy}
          zIndex={1000}
          loaderProps={{
            size: 'lg',
            color: 'blue',
          }}
        />
        <Stack>
          {body ? (
            body
          ) : (
            <Text my={30} fz="lg">
              {label}
            </Text>
          )}

          <Group justify="space-between" grow>
            <Button onClick={handleClose} disabled={isBusy}>
              {cancelButtonText}
            </Button>
            <Button onClick={handleCallback} variant="outline" loading={isBusy} disabled={isBusy}>
              {confirmButtonText}
            </Button>
          </Group>
        </Stack>
      </Box>
    </Modal>
  );
};
